  import React,{ useState, useEffect,useRef} from 'react';
  import $ from "jquery";
  import "select2/dist/js/select2.min.js";
  import "select2/dist/css/select2.min.css";
  import { useParams, Link,Routes, Route,useHistory,useLocation } from 'react-router-dom';
  import Popup from '../popup_component/Popup';
  import imgPath from '../../images/trav_logo.png';
  import wappImg from '../../images/wpapp.png';
  import QRCode from 'react-qr-code';
  import * as animationjs from '../../animation';
  
  import './Signup.css';
  
  function Register() {
    const { type } = useParams();
    const [ip, setIP] = useState('');

    //  useEffect(() => {
    //    const location = useLocation();
    //   console.log("start",window.fbq);
    //   window.fbq && window.fbq('track', 'PageView');
    // }, [location]);
    
  // const [thankpop, setThankpop] = useState(false);
    const [typeCheck,setTypeCheck] = useState('');
    const [typeName,setTypeName] = useState('Name of agency / entity');
    const [agencyActive,setAgencyActive] = useState(null); 
 
    const [websiteMsg,setWebsiteMsg] = useState('Website.'); 
    const [websiteActive,setWebsiteActive] = useState(null);
    const [onSuccess,setOnSuccess] = useState({flag:false,message:'',action:''});
    const [loginData,setLoginData] = useState({name:'',agency:'',pincode:'',city:'',mobile:'',email:'',otp:'',password:'',re_password:'',login_type:type,action:'registration',captcha:'',state:'',country:'',website:''});
  

    const [fnameMsgAlert,setFnameMsgAlert] = useState(false); 

    const [countryMsgAlert,setCountryMsgAlert] = useState(false); 
    const [mobileMsgAlert,setMobileMsgAlert] = useState(false); 
    const [emailMsgAlert,setEmailMsgAlert] = useState(false); 
    const [fnameActive,setFnameActive] = useState(null); 

    const [mobileActive,setMobileActive] = useState(null); 
    const [emailActive,setEmailActive] = useState(null); 


  

  


  
    const [fnameMsg,setFnameMsg] = useState('Please enter Name.'); 
    const [mobileMsg,setMobileMsg] = useState('Please enter Mobile no.'); 
    const [countryMsg,setCountryMsg] = useState('Please Select Country code.'); 
    const [emailMsg,setEmailMsg] = useState('Please enter email.'); 
  
    const [captchamsg,setCaptchamsg] = useState('Please enter captcha.'); 
    const [captchaVal,setCaptchaVal] = useState(null);
    const [succMsg,setSuccMsg] = useState(false); 
    const [captchamsgAlert,setCaptchamsgAlert] = useState(false);
  
  
    const fnameRef = useRef(null);


    const mobileRef = useRef(null);
    const emailRef = useRef(null);

  
   

    useEffect(()=>{
     
      getPagetitle();
      getIpData();
       document.getElementById("headerbox").style.display = "none";
        document.getElementById("footerbox").style.display = "none";
      document.addEventListener("keyup", keypressAct);
      document.addEventListener("mousedown", handleClick);
      return(()=>{
        document.removeEventListener("mousedown", handleClick);
        document.removeEventListener("keyup", keypressAct);
      })

    },[]);
  
    useEffect(()=>{
      if(succMsg==false){
        document.getElementById('email').focus();
        setCaptcha();
      }
  
     
    },[]);
  
   
    useEffect(()=>{  
      fnCountryCode();
      console.log(type);
        setTypeCheck('Agent');
        setTypeName('Name of agency / entity');
    
    },[type]);

    
    const getPagetitle = ()=>{
        document.title = 'Agent Registration';    
    }
  const fnCountryCode=()=>{
    const api_url = 'https://www.travsie.com/admin/';
    let formData = new FormData(); 
    formData.append('action','getcountrycode');
    return fetch(api_url+"ajax_login.php",{
      method:'POST',
      headers: {
        'Accept':'application/json',
      },
      body:formData
      }).then((response)=> response.text()).then((resData)=> {
      document.getElementById("getcountry").innerHTML=resData;
      $("#countrycode").select2();
    })
  }
    const supplierData = [
      {image:'supplier_icon_8.png', data:'Enter any target market without having a physical presence'},
      {image:'icon_7.png', data:'Sell, promote and service, all on a single platform'},
      {image:'agent_icon_7.png', data:'Digitizing your business leads to efficient processes'},
      {image:'agent_icon_8.png', data:'Predictive analytics to forcast & grow your business '},
      {image:'supplier_icon_2.png', data:'Real-time access to agents market – No old-school emails'},
      {image:'icon_6.png', data:'Business opportunities through Travsie travel agents’ network'},
    ];
  
    const agentData = [
      {image:'agent_icon_2.png', data:'Customize, Quote & Book - All in Just 2 Minutes'},    
      {image:'agent_icon_10.png', data:"Direct Invoicing from DMC's - In Your Agency's Name"},
      {image:'agent_icon_3.png', data:'No Middleman - Real time access to suppliers'},
      {image:'agent_icon_4.png', data:'Simple & Transparent, with fair pricing for all'},
      {image:'agent_icon_9.png', data:'Digitizes your business - no old school email'},
      {image:'agent_icon_6.png', data:'Customer Service Guaranteed.'},
    ];
  
    const handleClick = e => {
  
      if(document.getElementById('fname').value!=''){
        if (fnameRef.current && !fnameRef.current.contains(e.target)){
          setFnameActive('active'); 
        }
      }else{
        if (fnameRef.current && !fnameRef.current.contains(e.target)){
          setFnameActive(null); 
        }
      }
  
    if(document.getElementById('agencyName').value!=''){     
        setAgencyActive('active'); 
    }
    if(document.getElementById('agencyName').value==''){     
      setAgencyActive(null); 
    }

    
    if(document.getElementById('websiteName').value!=''){     
        setWebsiteActive('active'); 
    }
    if(document.getElementById('websiteName').value==''){     
      setWebsiteActive(null); 
    }
   
      if(document.getElementById('mobile').value!=''){
        if (mobileRef.current && !mobileRef.current.contains(e.target)){
          setMobileActive('active'); 
        }
      }else{
        if (mobileRef.current && !mobileRef.current.contains(e.target)){
          setMobileActive(null); 
        }
      }
      if(document.getElementById('email').value!=''){
        if (emailRef.current && !emailRef.current.contains(e.target)){
          setEmailActive('active'); 
        }
      }else{
        if (emailRef.current && !emailRef.current.contains(e.target)){
          setEmailActive(null); 
        }
      }
  
    }
  
    const keypressAct = e => {
      if(e.keyCode===9){
        if(e.target.id=='fname'){
          setFnameActive('active'); 
        }
         if(e.target.id=='agencyName'){
        setAgencyActive('active'); 
      }

      if(e.target.id=='websiteName'){
        setWebsiteActive('active'); 
      }

        if(e.target.id=='mobile'){
          setMobileActive('active'); 
        }
        
        if(e.target.id=='email'){
          setEmailActive('active'); 
        }
  
        
        
      
       
      }
    }
  
    const mAction = (idd)=>{
      if(document.querySelector('#'+idd) != null) {
        if(idd=='fname'){
          if(document.querySelector('#'+idd).value=='') {
            setFnameActive('active'); 
            document.querySelector('#'+idd).focus();
            return false;
          }else{
            setFnameActive(null);
          }
        }
        else if(idd=='agencyName'){
        if(document.querySelector('#'+idd).value=='') {
          setAgencyActive('active'); 
          document.querySelector('#'+idd).focus();
          return false;
        }else{
          setAgencyActive(null);
        }
      }else if(idd=='websiteName'){
        if(document.querySelector('#'+idd).value=='') {
          setWebsiteActive('active'); 
          document.querySelector('#'+idd).focus();
          return false;
        }else{
          setWebsiteActive(null);
        }
      }else if(idd=='mobile'){
          if(document.querySelector('#'+idd).value=='') {
            setMobileActive('active'); 
            document.querySelector('#'+idd).focus();
            return false;
          }else{
            setMobileActive(null);
          }
        }
        else if(idd=='email'){
          if(document.querySelector('#'+idd).value=='') {
            setEmailActive('active'); 
            document.querySelector('#'+idd).focus();
            return false;
          }else{
            setEmailActive(null);
          }
        }
      }
    }
  
    const handleChange = (e) => {
      setLoginData({
        ...loginData,
        [e.target.name]: e.target.value
      });
    }
    
    
   
  
  const formSubmit = (event)=>{
    event.preventDefault();
    let valid = true;
  
    var getCountryval=document.getElementById("countrycode").value;
    if(loginData.name==''){
      setFnameMsgAlert(true); 
      valid = false;
      setFnameMsg('Please enter your Name.'); 
      setTimeout(()=>{
        setFnameMsgAlert(false);
      },4000);
      return false;
    }
  
  
      
    
  
    if(getCountryval=='Country Code'){
      setCountryMsgAlert(true);
      valid = false;
      setCountryMsg('Please Select Country code.'); 
      setTimeout(()=>{
        setCountryMsgAlert(false);
      },4000);
      return false;
    }
    if(loginData.mobile==''){
      setMobileMsgAlert(true); 
      valid = false;
      setMobileMsg('Please enter your Mobile no.'); 
      setTimeout(()=>{
        setMobileMsgAlert(false);
      },4000);
      return false;
    }
  
    if(loginData.mobile!=null){
      var validmob = /^\d{8,10}$/;
    //  var getmob=document.getElementById("countrycode").value;
      // if(getmob=='+975'){
      //   validmob = /^\d{8}$/;
      // }
   
      if(!validmob.test(loginData.mobile)) {
        setMobileMsgAlert(true); 
        valid = false;
        setMobileMsg('Please enter valid Mobile no.'); 
        setTimeout(()=>{
          setMobileMsgAlert(false);
        },4000);
        return false;
      }
    }
  
    if(loginData.email==''){
      setEmailMsgAlert(true); 
      valid = false;
      setEmailMsg('Please enter your email address.'); 
      setTimeout(()=>{
        setEmailMsgAlert(false);
      },4000);
      return false;
    }
  
    if(loginData.email!=null){
        let emailCheck = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if(!emailCheck.test(loginData.email)) {
          setEmailMsgAlert(true);
          valid = false;
          setEmailMsg('Please enter your valid email address.'); 
            setTimeout(()=>{
              setEmailMsgAlert(false);
            },4000);
            return false;
        }
    }
  
   
    
  
 
  
  
  
    if(loginData.captcha==''){
      setCaptchamsgAlert(true);
      valid = false;
      setCaptchamsg('Please enter captcha.');
      setTimeout(()=>{
        setCaptchamsgAlert(false);
      },4000);
    }else if(loginData.captcha!=captchaVal.split(" ").join("")){
      setCaptchamsgAlert(true);
      valid = false;
      setCaptchamsg('Please enter valid captcha.');
      setTimeout(()=>{
        setCaptchamsgAlert(false);
      },4000);
    }else{
      setTimeout(()=>{
        setCaptchamsgAlert(false);
      },4000);
    }
  
    if(valid===true){
      fireApi();
    }
  }
  
  const setCaptcha = ()=> {
    var a = Math.ceil(Math.random() * 10)+ '';
    var b = Math.ceil(Math.random() * 10)+ '';       
    var c = Math.ceil(Math.random() * 10)+ '';  
    var d = Math.ceil(Math.random() * 10)+ '';  
    var e = Math.ceil(Math.random() * 10)+ '';  
    var f = Math.ceil(Math.random() * 10)+ '';  
    for(;a>9;){a=a/10;}
    for(;b>9;){b=b/10;}
    for(;c>9;){c=c/10;}
    for(;d>9;){d=d/10;}
    for(;e>9;){e=e/10;}
    for(;f>9;){f=f/10;}
    var code = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' '+ f;
    var code1 = a +  b +  c + d +  e + f;
    setCaptchaVal(code);
  }
  
  const fixTopact = (type)=>{
    if(type=='fname'){
      setFnameActive('active')
    }else if(type=='mobile'){
      setMobileActive('active')
    }else if(type=='email'){
      setEmailActive('active')
    }
    else if(type=='websiteName'){
      setWebsiteActive('active')
    }
    else if(type=='agencyName'){
      setAgencyActive('active')
    }
  }
  
  const resetF = ()=>{
      setFnameActive('');   
      setMobileActive('');
      setEmailActive('');
       setAgencyActive('');
       setWebsiteActive('');
      //setOtpActive('')


  }
  
  const api_url = 'https://www.travsie.com/admin/';
  
  const getIpData = ()=> {
    let formData = new FormData();  
    formData.append('action','getIP');
    return fetch(api_url+"ajax_login.php",{
      method:'POST',
      headers: {
        'Accept':'application/json',
      },
      body: formData
      }).then((response)=> response.text()).then((resData)=> {
        if(resData){
          setIP(resData)
        } 
    })
  }
  const history = useHistory();
 
  const fireApi = ()=>{
    getIpData(); 
    
    let formData = new FormData();  
    var getCountryval=document.getElementById("countrycode").value;
    var getwebsiteName=document.getElementById("websiteName").value;
    var getagencyName=document.getElementById("agencyName").value;
    formData.append('name',loginData.name);
    formData.append('mobile',loginData.mobile);
    formData.append('email', loginData.email);
    formData.append('countrycode',getCountryval);
    formData.append('websitename',getwebsiteName);
    formData.append('agencyname',getagencyName);
    formData.append('login_type', 'agent');
    formData.append('action','registration2');
    formData.append('ip',ip);
  
  
  
    return fetch(api_url+"ajax_login.php",{
      method:'POST',
      headers: {
        'Accept':'application/json',
      },
      body: formData
      }).then((response)=> response.json()).then((resData)=> {
          console.log(resData,resData.success);
        if(resData.success){
          setLoginData({name:'',mobile:'',email:'',login_type:'',action:'',ip:'',countrycode:'',websitename:'',agencyname:''});
          resetF();     
          setOnSuccess({flag:!onSuccess.flag,message:resData.success,action:'afterRegister'});
          history.push('/thankyou');
          // alert("Successful");
          // setThankpop(true);
        
         
        }else{
          setMobileMsgAlert(true); 
          setMobileMsg(resData.error); 
          setTimeout(()=>{
            setMobileMsgAlert(false);
          },4000);
          
          return false;
        }
    })
  }
  
    return (
      <>
            <header className="row_hb headerCntr">
                <div className="container">
                    <div className="row_hb">
                        <div className="logoBox">
                            <a href="#">
                                <img src={imgPath} alt="Travsie" />
                            </a>
                        </div>
                        <div className="float_r mar_t_10 mar_xs_t_5">
                            <a href="tel:+918800281599" className="callui"><i className="fa fa-phone"></i>+91-8800281599</a>
                        </div>
                    </div>
                </div>
            </header>
         {/* <div className={thankpop ? 'thankouter active':'thankouter'} id="thankblock">  
            <div className="row_hb text_align_c thankinner">
              <h2 className="txt_color_5 fnt_weight_800 mar_a_0 pad_a_0 fnt_size_50">
                Thank <span className="txt_color_3">You</span>
              </h2>
              <p className="row_hb pad_t_20 pad_b_20 fnt_size_20">
                Thank you for registering with Travsie. Our Team will 
                get in touch with you shortly.
              </p>
              <span className="btn btn-default" style={{'width': '40%','margin':'0 auto'}} onClick={()=>setThankpop(false)}>close</span>
            </div>    
        </div>     */}

        <div className="popbtn">   
          <div className="popitem">
            <a href="https://wa.me/8800281599?text=https://www.travsie.com/" className="wpapplink" target="_blank">
              <img src={wappImg} alt="Whatsapp Now" />
              <span className="row_hb text_align_c">Chat</span>
            </a>
          </div>
          <div className="popitem popitemsec">		
            <span className="pointer clickbtn" onclick="clickCall()">
              <a href="tel:+918800281599" >
                <i className="fa fa-phone"></i>
                <span className="row_hb text_align_c">Click to call </span>
              </a>
            </span>   
            </div>            
        </div>
      <section className="row_hb">
          {onSuccess.flag==true?<Popup setOnSuccess={setOnSuccess} data={onSuccess}/>:null}
          <div className="row_hb bg_col signUpCntr pad_t_30 pad_b_50">
            <div className="container">
                <div className="row_hb">
                  <div className="row_hb pad_b_35 teamMobile mob_p_b_0 pos_relative index_2">
                    <h2 className="row_hb txt_color_5 fnt_weight_800 mar_a_0 pad_a_0 mob_text_align_c fnt_size_50">Be Part of the  <span className="txt_color_3">Travsie revolution</span></h2>
                  </div>
                  <div className="row_hb pos_relative">
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 pad_l_0 pad_r_80 mob_p_r_0 pos_relative">
                      <div className="aboutAnimate moveimgBgSm signupMove index_1 pos_absolute"></div>
                      <div className="row_hb loginBox mob_m_t_b_custom border_rad_8 bg_white pos_relative index_2">
                          <span className="row_hb mar_b_5 text_align_c fnt_size_16 txt_color_3 fnt_weight_800 ">Why Work with Middlemen - Meet Suppliers Directly</span>
                          <p className="row_hb text_align_c fnt_size_12 mar_b_20" style={{'color':'#666'}}>Instant Pricing - No Middlemen </p>
                          <p className="row_hb mob_text_align_c txt_color_8 font_fam_halvetica mob_font_size_15 fnt_size_16">
                            <span className="row_hb text_align_c"><strong> Register as a <span className='txt_color_3'>Travsie {typeCheck}</span></strong></span>
                          </p>
                          <form className="row_hb mar_t_10" autoComplete="off" onSubmit={formSubmit}>
      
                            <div className="form-group pos_relative row_hb mar_t_15 mar_b_30"><span></span>
                              {fnameMsgAlert===true?<p className="errorMsgEl pos_absolute">{fnameMsg}</p>:null}
                              <span ref={fnameRef} onClick={()=>mAction('fname')} className={fnameActive==='active'?`pos_absolute ${fnameActive} chngElm`:"pos_absolute chngElm"}>Name</span>
                              <input type="text" onChange={handleChange} onClick={()=>fixTopact('fname')} id="fname"  value={loginData.name} className="form-control" autoComplete="new-fname" name="name"/> 
                            </div>
          
                          <div className="form-group pos_relative row_hb mar_t_15 mar_b_30"><span></span>
             
                            <span onClick={()=>mAction('agencyName')} className={agencyActive==='active'?`pos_absolute ${agencyActive} chngElm`:"pos_absolute chngElm"}>{typeName}</span>
                            <input type="text" onChange={handleChange} onClick={()=>fixTopact('agencyName')} id="agencyName"  value={loginData.agency} className="form-control" name="agency"/> 
                          </div>

                          <div className="form-group pos_relative row_hb mar_t_15 mar_b_30"><span></span>
                            <span onClick={()=>mAction('websiteName')}  className={websiteActive==='active'?`pos_absolute ${websiteActive} chngElm`:"pos_absolute chngElm"}>{websiteMsg}</span>
                            <input type="text" onChange={handleChange} onClick={()=>fixTopact('websiteName')} id="websiteName"  value={loginData.website} className="form-control" name="website"/> 
                          </div>

                            <div className="row_hb">
                              <div className="grid_xs_25 col-sm-6 mbx col-md-6 col-lg-3 pad_l_0 pad_r_0 mob_m_b_30">
                                <div className="form-group mar_a_0 pos_relative row_hb">
                                {countryMsgAlert===true?<p className="errorMsgEl pos_absolute" style={{'width':'320px','left':'0','top':'38px'}}>{countryMsg}</p>:null}
                                <span className="pos_absolute chngElm active">Country Code</span>
                                <div className='row_hb' id="getcountry">
                                  <select name="countrycode" id="countrycode" className="form-control" >
                                      <option value="0">Country Code</option>
                                      <option value="+91">+91</option>
                                  </select>  
                                </div>
                                                    
                                </div>
                              </div>
                              <div className="grid_xs_72  col-sm-6 mbx col-md-6 col-lg-9 pad_r_0 mob_p_l_0 float_r">
                                <div className="form-group pos_relative row_hb mar_t_15 mar_b_30"><span></span>
                                  {mobileMsgAlert===true?<p className="errorMsgEl pos_absolute">{mobileMsg}</p>:null}
                                  <span ref={mobileRef} onClick={()=>mAction('mobile')} className={mobileActive==='active'?`pos_absolute ${mobileActive} chngElm`:"pos_absolute chngElm"}>Mobile</span>
                                  <input type="text" onChange={handleChange} onClick={()=>fixTopact('mobile')} id="mobile"  value={loginData.mobile} className="form-control" name="mobile"/> 
                                </div>
                              </div>
                            </div>
      
                            <div className="row_hb mar_b_30 pos_relative">
                              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 pad_l_0 pad_r_0 mob_p_r_0">
                                <div className="form-group pos_relative mar_a_0 row_hb"><span></span>
                                  {emailMsgAlert===true?<p className="errorMsgEl pos_absolute">{emailMsg}</p>:null}
                                  <span ref={emailRef} onClick={()=>mAction('email')} className={emailActive==='active'?`pos_absolute ${emailActive} chngElm`:"pos_absolute chngElm"}>Email</span>
                                  <input type="text" onChange={handleChange} onClick={()=>fixTopact('email')} id="email"  value={loginData.email} className="form-control" name="email"/> 
                                  {/*<a onClick={fireOtp} className="getOtp txt_color_3 font_fam_halvetica fnt_size_12 pos_absolute index_2">Get OTP<i className="fa fa-caret-right pad_l_5" aria-hidden="true"></i></a>*/}
                                </div>
                              </div>

                            </div>
                            
      
                            
      
                            <div className="row_hb txcapt">
                              <span className="row_hb txtDesElm">Please enter code</span>
                              <div className="deskWith">
                                <div className="capchaleft">
                                  <span className="txtCaptcha">{captchaVal}</span>
                                  <a href="javascript:void(0);" onClick={setCaptcha} id="btnrefresh" style={{color:'#000',fontSize: '12px'}}><i className="fa fa-refresh" aria-hidden="true" style={{color:'#fc901b',fontSize: '18px', padding: '11px 6px'}}></i></a>  
                                </div>
                                <div className="capchaleft last">
                                  <input type="text" name="captcha" maxLength="6" onChange={handleChange}  autoComplete="off" value={loginData.captcha} className="form-control"/>
                                </div>
      
                                <div className="row_hb pos_relative">
                                  {captchamsgAlert===true?<p className="row_hb captchError pos_absolute">{captchamsg}</p>:null}
                                </div>
                              </div>
                              <button className="btn fnt_size_13 bg_light_blue txt_color_4 btn_hov pad_a_8 pull-right grid_xs_100">Register Me <i className="fa fa-angle-right pad_l_10" aria-hidden="true"></i></button>
      
                            </div>
                          </form>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 pad_r_0 mob_p_l_0">
                      <div className="row_hb">
                        <div className="row_hb pad_b_35 mob_text_align_c">
      
                            {type=='supp' || type=='hotelier'?<h2 className="row_hb txt_color_3 fnt_weight_700 mar_a_0 pad_a_0 text_align_c fnt_size_18">Connect with agents without physical presence! </h2>:<h2 className="row_hb txt_color_3 fnt_weight_700 mar_a_0 pad_a_0 text_align_c fnt_size_20">Create Trust & Goodwill Directly with Suppliers (DMC's)</h2>}
      
                            <p className="row_hb mar_a_0 pad_t_5 fnt_size_13 text_align_c" style={{'color':'#666'}}>Let suppliers know you and your business personally.</p>
                        </div>
                        
                        <div className="row_hb" >                      
                          {agentData.length>0?
                            <div className="row_hb">
                                {agentData.map((item,indx)=>
                                <div key={`team_${indx}`} className="col-xs-12 col-sm-4 col-md-4 col-lg-4 pad_l_0">
                                  <div className={indx>3?"mar_b_0 row_hb connectRegBox mob_min_ht border_rad_8 text_align_c pos_relative":`row_hb connectRegBox mob_min_ht border_rad_8 text_align_c pos_relative`}>
                                      <img src={`${window.location.origin}/images/${item.image}`} alt=""/>
                                      <p className="font_fam_halvetica row_hb fnt_size_13 txt_color_8 line_height_20"> {item.data}</p>
                                  </div>
                                </div>
                                )}
                            </div>
                          :null}
                        </div>
                       
                      </div>
                    </div>  
                  </div>
                </div>
            </div>
          </div>
      </section>

              <footer className="row_hb pad_t_40 bg_footer">
                <div className="container">
                    <div className="row_hb">
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 pad_l_0 pad_r_50 mob_p_r_0 m_dx_50">
                          <div className="row_hb bor_r_1 nomobBor">
                            <h3 className="row_hb txt_color_3 mob_font_size_18 fnt_size_22 fnt_weight_900 mar_t_0">Travshop Private Limited </h3>
                            <p className="font_fam_roboto txt_color_1 mob_font_s_14 fnt_size_15 line_height_24">315/274, 2nd Floor Westend Marg<br/> Said-ul-Ajaib, New Delhi - 110030<br/> +91 - 9818278899</p>
                            <img src="images/adtoi-logo.jpg" alt="adtiologo" style={{'width': '150px'}} />
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 mob_p_r_0 mob_p_l_0 mob_p_t_25">
                            <h3 className="row_hb txt_color_3 fnt_size_22 mob_font_size_18 fnt_weight_900 mar_t_0">Company </h3>
                            <ul className="row_hb font_fam_roboto fnt_size_15 mob_font_s_14 line_height_24">
                                <li>
                                  <Link to="/#"  className="mLink txt_color_1">About Us</Link>
                                </li>
                                <li>
                                   <Link to="/#"  className="mLink txt_color_1">Travsie for Agents</Link>
                                </li>
                                <li>                     
                                   <Link to="/#"  className="mLink txt_color_1">Travsie for Suppliers</Link>
                                </li>
                                <li>
                                <Link to="/#"  className="mLink txt_color_1">Benefits</Link>
                                </li>
                                <li>        
                                    <Link to="/#"  className="mLink txt_color_1">Blogs</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 mob_p_r_0 mob_p_l_0 mob_p_t_25">
                            <h3 className="row_hb txt_color_3 fnt_size_22 mob_font_size_18 fnt_weight_900 mar_t_0">Others </h3>
                            <ul className="row_hb font_fam_roboto txt_color_1 mob_font_s_14 fnt_size_15 line_height_24">
                                <li>                         
                                  <Link to="/#"  className="mLink txt_color_1">Terms and Conditions</Link>
                                </li>
                                <li>
                                <Link to="/#"  className="mLink txt_color_1">Unsubscribe</Link>
                                </li>
                                <li>
                                  <Link to="/#"  className="mLink txt_color_1">Privacy Policy</Link>
                                </li>
                                <li>
                                  <Link to="/#"  className="mLink txt_color_1">Infringement Policy</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2 pad_r_0 mob_p_r_0 mob_p_l_0 mob_p_t_25">
                            <h3 className="row_hb txt_color_3 fnt_size_22 mob_font_size_18 fnt_weight_900 mar_t_0">Contact </h3>
                            <ul className="row_hb font_fam_roboto txt_color_1 mob_font_s_14 fnt_size_15 line_height_24">
                                <li><a href="mailto:discover@travsie.com" className="txt_color_1">discover@travsie.com</a></li>
                            </ul>
                        </div>
                        <div className="row_hb text_align_c" style={{'padding': '15px 0px','font-size':'11px','color': 'rgb(102, 102, 102)'}}>
                            <p style={{'margin': '0px'}}>CopyRight © 2025 Travshop Pvt. Ltd. All Rights Reserved</p>
                        </div>
                    </div>
                </div>
              </footer>
      </>
    );
  }
  
  export default Register;






